// extracted by mini-css-extract-plugin
export default {"card":"PEsvO","header":"GnVap","inner":"asJRS","tooltip":"RkPkJ","tooltipText":"K1VhU"};